import { Object3D } from "three"
import { GLTF } from "three/examples/jsm/Addons.js"
import { clone as cloneSkinnedHierarchy } from "three/examples/jsm/utils/SkeletonUtils.js"
import { getLoadedModel } from "@/lib/gltf-cache"
import { AbstractModel } from "./AbstractModel"

export class GLBModel implements AbstractModel {
  constructor(public readonly path: string) {}

  get url(): string {
    return this.path
  }

  get key(): string {
    const base = this.path.split('/').pop() ?? this.path
    return base.replace(/\.glb$/i, '')
  }

  isLoaded = false
  gltf: GLTF | null = null

  getModel(): Object3D | null {
    const src = this.gltf?.scene
    if (!src) {
      return null
    }

    // Обычный Object3D.clone() не перепривязывает skeleton.bones к клонированным костям —
    // анимация и деформация на клоне «молчат», пока микшер крутит другие объекты.
    const mesh = cloneSkinnedHierarchy(src) as Object3D

    return mesh
  }

  load(onLoad: () => void, onError?: (error: unknown) => void) {
    getLoadedModel(this.path)
      .then((gltf) => {
        this.isLoaded = true
        this.gltf = gltf
        onLoad()
      })
      .catch((error) => {
        console.error('[GLBModel] failed to load:', this.path, error)
        onError?.(error)
      })
  }
}
